import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import LazyComponent from '../../../../LazyComponent';

export default universal(
    universalImport({
        chunkName: () => 'LazyCSPLandingChunk',
        path: () => path.join(__dirname, './CSPLandingConnect'),
        resolve: () => require.resolveWeak('./CSPLandingConnect'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "LazyCSPLandingChunk", webpackPreload: true */ './CSPLandingConnect'
                ),
            ]).then((proms) => proms[0]),
    }),
    LazyComponent.loaderResource
);
